export const stripFrameLocations = (value) => (value !== null && value !== void 0 ? value : '')
    .replace(/ \(https?:\/\/[^\s)]+?:\d+:\d+\)/g, '')
    .replace(/https?:\/\/[^\s)]+?:\d+:\d+/g, '<anonymous>');
